var e=Symbol("SDC.NativeHandle");export{e as a};